import { render, staticRenderFns } from "./ListServices.vue?vue&type=template&id=f97581d4&scoped=true&"
import script from "./ListServices.vue?vue&type=script&lang=js&"
export * from "./ListServices.vue?vue&type=script&lang=js&"
import style0 from "./ListServices.vue?vue&type=style&index=0&id=f97581d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97581d4",
  null
  
)

export default component.exports